"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.css = exports.props = void 0;
var withCompInfo_1 = require("../../core/withCompInfo");
var constants_1 = require("./constants");
exports.props = withCompInfo_1.withCompInfo(['compData', 'compProps', 'compLayout', 'isMobileView'], function (_a) {
    var compData = _a.compData, compProps = _a.compProps, compLayout = _a.compLayout, isMobileView = _a.isMobileView;
    var min = compData.min, max = compData.max, value = compData.value, step = compData.step, stepType = compData.stepType, readOnly = compData.readOnly;
    var isDisabled = compProps.isDisabled, thumbShape = compProps.thumbShape, tickMarksShape = compProps.tickMarksShape, tickMarksPosition = compProps.tickMarksPosition, tooltipPosition = compProps.tooltipPosition, tooltipVisibility = compProps.tooltipVisibility, tooltipPrefix = compProps.tooltipPrefix, tooltipSuffix = compProps.tooltipSuffix, dir = compProps.dir;
    // TODO: support responsive layout
    var width = compLayout.width || 0;
    var height = compLayout.height || 0;
    return {
        width: width,
        height: height,
        min: min,
        max: max,
        value: value,
        step: step,
        stepType: stepType,
        isDisabled: isDisabled,
        readOnly: readOnly,
        thumbShape: thumbShape,
        tickMarksShape: tickMarksShape,
        tickMarksPosition: tickMarksPosition,
        tooltipPosition: isMobileView ? 'normal' : tooltipPosition,
        tooltipVisibility: tooltipVisibility,
        tooltipPrefix: tooltipPrefix,
        tooltipSuffix: tooltipSuffix,
        dir: dir,
    };
});
var getTicksCssByShape = function (tickMarksShape) {
    if (tickMarksShape === 'line') {
        return {
            '--tickWidth': constants_1.Sizes.tickLineWidth + "px",
            '--tickHeight': constants_1.Sizes.tickLineHeight + "px",
        };
    }
    return {
        '--tickWidth': constants_1.Sizes.tickDotSize + "px",
        '--tickHeight': constants_1.Sizes.tickDotSize + "px",
        '--tickBorderRadius': '50%',
    };
};
var getTicksCssByPosition = function (tickMarksPosition) {
    return {
        normal: { '--tickBottom': '0' },
        middle: { '--tickTop': '50%', '--tickTranslateY': '-50%' },
        across: { '--tickTop': '0' },
    }[tickMarksPosition];
};
var getThumbBorderRadius = function (styleProperties, thumbShape) {
    if (thumbShape === 'circle') {
        return '50%';
    }
    var defaultBorderRadiusByShape = {
        circle: '50%',
        square: '17px',
        rectangle: '37px',
        bar: '5px',
    };
    return (styleProperties.thumbBorderRadius || defaultBorderRadiusByShape[thumbShape]);
};
exports.css = withCompInfo_1.withCompInfo(['compProps', 'styleProperties'], function (_a) {
    var compProps = _a.compProps, styleProperties = _a.styleProperties;
    var trackSize = compProps.trackSize, thumbShape = compProps.thumbShape, tickMarksPosition = compProps.tickMarksPosition, tickMarksShape = compProps.tickMarksShape;
    return __assign(__assign({ '--trackHeight': trackSize + "%", '--thumbBorderRadius': getThumbBorderRadius(styleProperties, thumbShape) }, getTicksCssByPosition(tickMarksPosition)), (tickMarksShape !== 'none' && getTicksCssByShape(tickMarksShape)));
});
//# sourceMappingURL=Slider.js.map